import { render, staticRenderFns } from "./DummyCofocus2.vue?vue&type=template&id=683fd587&scoped=true&"
import script from "./DummyCofocus2.vue?vue&type=script&lang=js&"
export * from "./DummyCofocus2.vue?vue&type=script&lang=js&"
import style0 from "./DummyCofocus2.vue?vue&type=style&index=0&id=683fd587&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683fd587",
  null
  
)

export default component.exports